import { motion } from 'framer-motion';
import { springs } from '../lib/animations';

interface ScoreBarProps {
  label: string;
  score: number;
}

export default function ScoreBar({ label, score }: ScoreBarProps) {
  const pct = (score / 10) * 100;
  const color =
    score >= 7 ? 'bg-cannabis-400' :
    score >= 4 ? 'bg-yellow-600' :
    'bg-red-700';

  return (
    <div className="flex items-center gap-3">
      <span className="text-cream/70 text-sm w-36 shrink-0">{label}</span>
      <div className="flex-1 bg-cannabis-800 rounded-full h-3 overflow-hidden">
        <motion.div
          className={`h-full rounded-full ${color}`}
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={springs.dramatic}
        />
      </div>
      <span className="text-cream font-mono text-sm w-10 text-right">{score.toFixed(1)}</span>
    </div>
  );
}
